import React, { Component } from 'react';
import axios from 'axios';
import TagManager from 'react-gtm-module';
import { HttpService } from '../services';

const AppContext = React.createContext();

export class AppProvider extends Component {
    state = {};
    tagManagerArguments = {};

    initializeGoogleAnalytics = gaId => {
        const script = document.createElement('script');
        script.async = true;
        script.src = `https://www.googletagmanager.com/gtag/js?id=${gaId}`;
        document.head.appendChild(script);

        window.dataLayer = window.dataLayer || [];
        function gtag() {
            window.dataLayer.push(arguments);
        }
        window.gtag = window.gtag || gtag;
        window.gtag('js', new Date());
        window.gtag('config', gaId);
    };

    componentDidMount() {
        return axios.get('/config.json').then(config => {
            HttpService.setConfig(config.data);

            this.setState({ config: config.data });

            if (config.data.googleTagManagerId) {
                this.tagManagerArguments = {
                    gtmId: config.data.googleTagManagerId,
                    auth: config.data.googleTagManagerAuth,
                    preview: config.data.googleTagManagerEnvironment
                };

                TagManager.initialize(this.tagManagerArguments);
            }

            if (config.data.googleAnalyticsId) {
                this.initializeGoogleAnalytics(config.data.googleAnalyticsId);
            }
        });
    }

    render() {
        const { config } = this.state;

        return (
            <React.Fragment>
                {config && (
                    <AppContext.Provider
                        value={{
                            state: {
                                config
                            }
                        }}
                    >
                        {this.props.children}
                    </AppContext.Provider>
                )}
            </React.Fragment>
        );
    }
}

export const AppConsumer = AppContext.Consumer;
